import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {
	WorkstationConfiguration,
	WorkstationConfigurationService, WorkstationUser
} from "../../../../../../services/back/workstation-configuration.service";
import {tap} from "rxjs/operators";
import {finalize, Observable, of, Subscription, switchMap} from "rxjs";
import {
	WorkstationDetailData,
	WorkstationDetailService
} from "../../../../../../services/front/workstation-detail.service";
import {CommonModule} from "@angular/common";
import {DashboardPageLoaderComponent} from "../../../../../global/title-content-loader/dashboard-page-loader.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-workstation-users',
	imports: [
		CommonModule,
		DashboardPageLoaderComponent,
		TranslateModule
	],
  templateUrl: './workstation-users.component.html',
  styleUrl: './workstation-users.component.scss'
})
export class WorkstationUsersComponent implements OnInit, OnDestroy {
	workstation: WorkstationConfiguration;
	workstationUsers: WorkstationUser[] = [];
	tenantId: string;

	private workstationService = inject(WorkstationConfigurationService);
	private workstationDetailService = inject(WorkstationDetailService);

	_loading: boolean;

	private subscriptions: Subscription = new Subscription();

	ngOnInit() {
		this.subscriptions.add(this.workstationDetailService.getWorkstationDetailDataChanges()
			.pipe(tap(data => this.setWorkstationDetailData(data)))
			.subscribe(() => this.initialize()));
	}

	private setWorkstationDetailData(data: WorkstationDetailData): void {
		this.workstation = data.workstation;
		this.tenantId = data.tenantId;
	}

	private initialize(): void {
		this.subscriptions.add(this.switchLoading()
			.pipe(
				switchMap(() => this.workstationService.getWorkstationConfigurationUsers(this.tenantId, this.workstation.id)),
				tap((data) => this.workstationUsers = data),
				finalize(() => this.switchLoading())
			).subscribe())
	}

	private switchLoading(): Observable<{}> {
		this._loading = !this._loading;
		return of({});
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}
}
